import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";
import { LOGIN_PATH } from "../../../branch/tenant";

const axiosInstance = axios.create({
    baseURL: enum_api_uri.api_uri,
    headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(
    config => {
        const accessToken = useAuthStore.getState().accessToken;
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    error => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = useAuthStore.getState().refreshToken;
                if (!refreshToken) throw new Error("No refresh token");

                const { data } = await axios.post(enum_api_uri.refresh, { refreshToken });

                useAuthStore.getState().setAuth({ accessToken: data.accessToken });

                originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                console.error("Refresh Token Expired. Redirecting to login...");
                useAuthStore.getState().logout();

                axiosInstance.defaults.headers.common["Authorization"] = "";

                window.location.replace(LOGIN_PATH);
            }
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
